import { Entity, EntityRepositoryType, PrimaryKey, Property, ManyToOne, OneToMany } from '@mikro-orm/postgresql'
import { EntityRepository } from '@mikro-orm/postgresql'
import { Field, Control } from "../../framework/model-util"
import { BaseEntity } from '../core/core.entities'
import { v4 as uuid } from 'uuid'

class GeneralProvisionRepository extends EntityRepository<GeneralProvision> {}

/**
 * General reseller provision, applied to all resellers
 * if specific is not applied
 */
@Entity({ tableName: 'provision_general', repository: () => GeneralProvisionRepository })
export class GeneralProvision extends BaseEntity {
	[EntityRepositoryType]?: GeneralProvisionRepository

	@PrimaryKey()
	id: string = uuid()

	@Property()
	clientId: string

	@Property()
	serviceProviderId: string

	@Property({ columnType: 'numeric' , nullable: true })
	@Control({
		widgetId: 'inlineEdit',
		layout: 'inline',
		settings: {
			unit: "%",
			dialogTitle: "editProvision",
			dialogText: "editProvisionWarning"
		}
	})

	@Field({ type: 'Number', localized: false, required: false })
	provision?: number

	@OneToMany(() => SpecificProvision, specificProvision => specificProvision.generalProvision, { lazy: true })
	specificProvisions: SpecificProvision[]

	constructor(clientId: string, serviceProviderId: string) {
		super()
		this.clientId = clientId
		this.serviceProviderId = serviceProviderId
	}
}

class SpecificProvisionRepository extends EntityRepository<SpecificProvision> {}

/**
 * Specific provision overrides tied to a general provision,
 * scoped to resellers, product groups and products
 */
@Entity({ tableName: 'provision_specific', repository: () => SpecificProvisionRepository })
export class SpecificProvision extends BaseEntity {
	[EntityRepositoryType]?: SpecificProvisionRepository

	@PrimaryKey()
	id: string = uuid()

	@ManyToOne(() => GeneralProvision, { lazy: true })
	generalProvision: GeneralProvision

	@Control({ widgetId: 'tagEditorCheckbox' })
	@Property()
	@Field({ type: 'Array', localized: false, required: true })
	resellers: string[]

	@Control({ widgetId: 'tagEditorCheckbox' })
	@Property({ nullable: true })
	@Field({ type: 'Array', localized: false, required: false })
	productGroups?: number[]

	@Property({ nullable: true })
	products?: number[]

	@Property({ columnType: 'numeric' })
	@Control({ settings: { unit: "%" } })
	@Field({ type: 'Number', localized: false, required: true })
	provision: number

	constructor(generalProvision: GeneralProvision) {
		super()
		this.generalProvision = generalProvision
	}
}
